import { ico } from './icons.js';
import { S, UI } from './store.js';
import { $, esc } from './util.js';

export function toast(m){const r=$('#toast-root');r.innerHTML=`<div class="toast" role="status">${esc(m)}</div>`;clearTimeout(toast.t);toast.t=setTimeout(()=>r.innerHTML='',2600)}

export function applyTheme(){const r=document.documentElement;if(S.theme==='system')r.removeAttribute('data-theme');else r.setAttribute('data-theme',S.theme)}

export function openModal(title,body,foot,cls){UI.modal={title,body,foot,cls:cls||''};renderModal()}

export function closeModal(){UI.modal=null;renderModal()}

export function renderModal(){
  const r=$('#modal-root'),m=UI.modal;if(!m){r.innerHTML='';return}
  r.innerHTML=`<div class="ovl" data-act="mclose"></div><div class="mod ${m.cls}" role="dialog" aria-modal="true" aria-label="${esc(m.title)}"><div class="mod-h"><h3>${esc(m.title)}</h3><button class="ib" data-act="mclose" aria-label="Close">${ico('x',18)}</button></div><div class="mod-b">${m.body}</div>${m.foot?`<div class="mod-f">${m.foot}</div>`:''}</div>`;
  const f=$('.mod input,.mod select,.mod textarea');if(f&&!m.cls)f.focus();
}
